import { Flex } from "antd"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
import { SwitchInput } from "ui/Input/SwitchInput"
import { Text } from "ui/Typography"
import { TRIP_PRICE } from "../../utils/constants"
import { useEffect, useState } from "react"

export const PricesAndTypes = ({ form, title, record }) => {
  const [t] = useTranslation()
  const [adultsAllowed, setAdultsAllowed] = useState(record?.adults_allowed ?? true)
  const [childrenAllowed, setChildrenAllowed] = useState(record?.children_allowed)
  const [infantsAllowed, setInfantsAllowed] = useState(record?.infants_allowed)
  const [passengersAllowed, setPassengersAllowed] = useState(record?.passengers_allowed)

  const handleSwitchChange = (field, checked, updateStateFn, amountField) => {
    form.setFieldValue(field, checked)
    updateStateFn(checked)
    if (checked) {
      form?.setFieldValue(amountField, 0)
    } else {
      form?.setFieldValue(amountField, null)
    }
  }

  const handleInputChange = (field, value, allowed) => {
    form.setFieldValue(field, value)
    if (field !== "price_per_person") {
      form.setFieldValue(allowed, true)
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      [TRIP_PRICE.PRICE_ADULT]: record?.[TRIP_PRICE.PRICE_ADULT],
      [TRIP_PRICE.PRICE_INFANT]: record?.[TRIP_PRICE.PRICE_INFANT],
      [TRIP_PRICE.PRICE_CHILD]: record?.[TRIP_PRICE.PRICE_CHILD],
      [TRIP_PRICE.PRICE_PASSENGER]: record?.[TRIP_PRICE.PRICE_PASSENGER],
    });
  }, [record, form]);

  return (
    <>
      {title && (
        <Text variant="sub" size="md">
          {title}
        </Text>
      )}
      <Flex vertical gap={4} className="w-100 mt-m">
        <SwitchInput
          text={t("experiences.scheduling.sections.length_and_rates.adults")}
          subText={t("experiences.scheduling.sections.length_and_rates.available_by_default")}
          checked={adultsAllowed}
          handleSwitchChange={(checked) => handleSwitchChange(TRIP_PRICE.ADULTS_ALLOWED, checked, setAdultsAllowed, TRIP_PRICE.PRICE_ADULT)}
          handleInputChange={(value) => handleInputChange(TRIP_PRICE.PRICE_ADULT, value)}
          inputFormItemName={TRIP_PRICE.PRICE_ADULT}
        />
        <SwitchInput
          text={t("experiences.scheduling.sections.length_and_rates.children")}
          subText={t("experiences.scheduling.sections.length_and_rates.under_12_years")}
          checked={childrenAllowed}
          handleSwitchChange={(checked) => handleSwitchChange(TRIP_PRICE.CHILDREN_ALLOWED, checked, setChildrenAllowed, TRIP_PRICE.PRICE_CHILD)}
          handleInputChange={(value) => handleInputChange(TRIP_PRICE.PRICE_CHILD, value, TRIP_PRICE.CHILDREN_ALLOWED)}
          inputFormItemName={TRIP_PRICE.PRICE_CHILD}
        />
        <SwitchInput
          text={t("experiences.scheduling.sections.length_and_rates.infants")}
          subText={t("experiences.scheduling.sections.length_and_rates.under_2_years")}
          checked={infantsAllowed}
          handleSwitchChange={(checked) => handleSwitchChange(TRIP_PRICE.INFANTS_ALLOWED, checked, setInfantsAllowed, TRIP_PRICE.PRICE_INFANT)}
          handleInputChange={(value) => handleInputChange(TRIP_PRICE.PRICE_INFANT, value, TRIP_PRICE.INFANTS_ALLOWED)}
          inputFormItemName={TRIP_PRICE.PRICE_INFANT}
        />
        <SwitchInput
          text={t("experiences.scheduling.sections.length_and_rates.passengers")}
          infoText={t("experiences.scheduling.sections.length_and_rates.passengers_info")}
          checked={passengersAllowed}
          handleSwitchChange={(checked) => handleSwitchChange(TRIP_PRICE.PASSENGERS_ALLOWED, checked, setPassengersAllowed, TRIP_PRICE.PRICE_PASSENGER)}
          handleInputChange={(value) => handleInputChange(TRIP_PRICE.PRICE_PASSENGER, value, TRIP_PRICE.PASSENGERS_ALLOWED)}
          inputFormItemName={TRIP_PRICE.PRICE_PASSENGER}
        />
      </Flex>
    </>
  )
}

PricesAndTypes.propTypes = {
  form: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
    setFieldsValue: PropTypes.func.isRequired,
  }).isRequired,
  title: PropTypes.string,
  record: PropTypes.shape({
    children_allowed: PropTypes.bool,
    infants_allowed: PropTypes.bool,
    passengers_allowed: PropTypes.bool,
  }),
}
